module.exports = __webpack_public_path__ + "static/media/map@3x.3f53440e.png";